import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { RouterLink } from '@angular/router'
import { UserWithSummary } from '@core/interfaces/kpis.interface'
import { ProgressBarComponent } from '../progress-bar/progress-bar.component'

@Component({
  selector: 'kpis-score-card',
  imports: [ProgressBarComponent, RouterLink],
  templateUrl: './kpis-score-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KpisScoreCardComponent {
  user = input.required<UserWithSummary>()
  link = input.required<string | string[]>()
}
